"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cenadi": {
    "bc083d6e": [{
      "hkey": "378bd17b",
      "slug": "cenadi",
      "name": "Cenadi",
      "primary": true,
      "skipSearch": false
    }],
    "cara": [{
      "hkey": "378bd17b",
      "slug": "cenadi",
      "name": "Cenadi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9a0d07e9": [{
      "hkey": "bd05e0a3",
      "slug": "crocicella",
      "name": "Crocicella",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-crocicelle": [{
      "hkey": "bd05e0a3",
      "slug": "crocicella",
      "name": "Crocicella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d22c7515": [{
      "hkey": "378bd17b",
      "slug": "cenadi",
      "name": "Cenadi",
      "primary": true,
      "skipSearch": false
    }],
    "fossella": [{
      "hkey": "378bd17b",
      "slug": "cenadi",
      "name": "Cenadi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6a8dfb18": [{
      "hkey": "378bd17b",
      "slug": "cenadi",
      "name": "Cenadi",
      "primary": true,
      "skipSearch": false
    }],
    "minghozzo": [{
      "hkey": "378bd17b",
      "slug": "cenadi",
      "name": "Cenadi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b8665cca": [{
      "hkey": "378bd17b",
      "slug": "cenadi",
      "name": "Cenadi",
      "primary": true,
      "skipSearch": false
    }],
    "minichello": [{
      "hkey": "378bd17b",
      "slug": "cenadi",
      "name": "Cenadi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "77e3ab37": [{
      "hkey": "378bd17b",
      "slug": "cenadi",
      "name": "Cenadi",
      "primary": true,
      "skipSearch": false
    }],
    "ravecchia": [{
      "hkey": "378bd17b",
      "slug": "cenadi",
      "name": "Cenadi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d8e135e4": [{
      "hkey": "378bd17b",
      "slug": "cenadi",
      "name": "Cenadi",
      "primary": true,
      "skipSearch": false
    }],
    "ritegno": [{
      "hkey": "378bd17b",
      "slug": "cenadi",
      "name": "Cenadi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "71155f1f": [{
      "hkey": "378bd17b",
      "slug": "cenadi",
      "name": "Cenadi",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "378bd17b",
      "slug": "cenadi",
      "name": "Cenadi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a764b059": [{
      "hkey": "378bd17b",
      "slug": "cenadi",
      "name": "Cenadi",
      "primary": true,
      "skipSearch": false
    }],
    "san-nicola": [{
      "hkey": "378bd17b",
      "slug": "cenadi",
      "name": "Cenadi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "83d17014": [{
      "hkey": "378bd17b",
      "slug": "cenadi",
      "name": "Cenadi",
      "primary": true,
      "skipSearch": false
    }],
    "torro": [{
      "hkey": "378bd17b",
      "slug": "cenadi",
      "name": "Cenadi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;